import React from "react";
import "./HomeFooter.css";

function HomeFooter() {
  return (
    <div className="homefooter-container">
      <p>LET’S REVOLITIONIZE</p>
      <div className="centerd-footer-text">
        <p>HEALTHCARE TOGETHER</p>
        <p>GET IN TOUCH</p>
      </div>
      <p className="lastfooter-text">TODAY!</p>
    </div>
  );
}

export default HomeFooter;
